import { SIDEBAR_ROOT_ID } from 'client/constants/editorIds'
import React, { ReactNode } from 'react'
import ReactDOM from 'react-dom'
import { CloseButton } from 'src/editor/shared/ui-lib/buttons'
import { twMerge } from 'tailwind-merge'

export interface SidebarSecondLevelProps {
  isOpened: boolean
  title: string
  onClose: () => void
  children: ReactNode
}

export const SidebarSecondLevel = ({
  isOpened,
  title,
  onClose,
  children,
}: SidebarSecondLevelProps) => {
  return isOpened
    ? ReactDOM.createPortal(
        <div
          className={twMerge(
            'absolute top-0 left-full h-full w-full bg-bgPrimaryBase',
            'z-52', // NOTE: need to be greater than a popup
            'overflow-y-auto border-border200 border-r',
            'p-[var(--sidebar-padding)]',
          )}
        >
          <div className="mb-6 flex items-center justify-between gap-1 break-all">
            <span className="text-heading-4">{title}</span>
            <CloseButton onClick={onClose} />
          </div>
          {children}
        </div>,
        document.getElementById(SIDEBAR_ROOT_ID) as HTMLElement,
      )
    : null
}
